import axios from 'axios'

// import { ParticipantWithActivityCode } from '../../DataTypes/PersonalInfoTypes'
//import { fakeAPICall } from '../utils/testUtils'

const {  REACT_APP_API_HOSTNAME } = process.env

const defaultErrorHandler = (e: Error) => {
	throw e
}

export const validateAddress = async (addressInfo: any) => {
	// if(NODE_ENV !== 'production') {
	// 	return await fakeAPICall(() => ({data: 'data', status: 201})).catch(defaultErrorHandler)
	// }

	return await axios.post(`${REACT_APP_API_HOSTNAME}/addressValidation `, addressInfo).catch(defaultErrorHandler)
	//return await axios.post(` https://c38yp49t27.execute-api.us-east-1.amazonaws.com/dev-us-east-1/api/addressValidation`, addressInfo).catch(defaultErrorHandler);
 	//return await axios.post(` https://c38yp49t27.execute-api.us-east-1.amazonaws.com/dev-us-east-1/api/validateaddress`, addressInfo).catch(defaultErrorHandler);
}
